import { Parent } from '@/interfaces/parent.interface';
import { Types } from 'mongoose';
import { DeleteResponseDTO } from '@/classes/dto/delete.response.dto';
import { API, ApiRequestOptions } from './api.class';
import { CreateParentRequestDto } from '../dto/parent-handler/request/CreateParent.request.dto';
import {UpdateParentRequestDto} from '@/classes/dto/parent-handler/request/UpdateParent.request.dto';
import {FindParentRequestDto} from '@/classes/dto/parent-handler/request/FindParent.request.dto';
import {DeactivationRequestDto} from '@/classes/dto/_common/request/Deactivation.request.dto';
import {ActivationRequestDto} from '@/classes/dto/_common/request/Activation.request.dto';
import { FindByIdOptionsRequestDto } from '@/classes/dto/_common/request/FindByIdOptions.request.dto';
/**
 * This class is used for communicating with ParentHandler microservice
 * @class ParentHandlerApi
 * @author mklaczinski
 */
export class ParentHandlerApi extends API {
    static service = 'parent-handler';

    static async create(doc: CreateParentRequestDto): Promise<Parent> {
        return this.post(``, doc);
    }
    static async getCanUpdateRelated(id: Types.ObjectId): Promise<boolean> {
        return this.get(`canUpdateRelated/${id}`);
    }
    static async find(data: FindParentRequestDto): Promise<{ parents: Parent[]; maxPage: number }> {
        return this.get(``, data);
    }
    static async findById(id: Types.ObjectId, options?: FindByIdOptionsRequestDto, requestOptions?: ApiRequestOptions): Promise<Parent> {
        return this.get(`${id}`, options, undefined, requestOptions);
    }
    static async update(id: Types.ObjectId, update: UpdateParentRequestDto): Promise<void> {
        return this.put(`${id}`, update);
    }
    static async deactivate(id: Types.ObjectId, data: DeactivationRequestDto): Promise<void> {
        return this.put(`deactivate/${id}`, data);
    }
    static async reactivate(id: Types.ObjectId, data: ActivationRequestDto): Promise<void> {
        return this.put(`reactivate/${id}`, data);
    }
    static async remove(id: Types.ObjectId): Promise<DeleteResponseDTO> {
        return this.delete(`${id}`);
    }
}
